const FullQrCodeSerialRegExp = /([0-9A-F]{12});(([0-9]{2})-([0-9]{1,5}).([0-9]{1,3}).([0-9]{1,5}) -([0-9]+))/;
const OnlySerialRegExp = /([0-9A-F]{12})/;
const Only1CQrCodeRegExp = /(([0-9]{2})-([0-9]{1,5}).([0-9]{1,3}).([0-9]{1,5}) -([0-9]+))/;
export function matchSerial(text) {
    const matches = text.toString().match(FullQrCodeSerialRegExp);
    if (matches) {
        return { serial: matches[1], qr_1c: matches[2] };
    }
    let result = { serial: undefined, qr_1c: undefined };
    const match_serial = text.toString().match(OnlySerialRegExp);
    if (match_serial) {
        result = { ...result, serial: match_serial[1] };
    }
    const match_1c = text.toString().match(Only1CQrCodeRegExp);
    if (match_1c) {
        result = { ...result, qr_1c: match_1c[1] };
    }
    return result;
}
